__turbopack_context__.v({
  "headingText": "vnCs8a_headingText",
});
